/**
 * BabyOS design tokens — canonical source of truth for JS/TS consumers.
 * Mirrors tailwind.config.ts (which is the CSS source).
 * When these change, update both files together.
 */

export const PACK_COLORS = {
  early_care:   { light: '#8AB89F', deep: '#5C8F76' },
  shopping:     { light: '#E8A87C', deep: '#C78560' },
  health:       { light: '#7BA7C4', deep: '#5A85A2' },
  school:       { light: '#D4A24C', deep: '#B0842E' },
  sports:       { light: '#9B7BB8', deep: '#7B5C97' },
  activity:     { light: '#6FA8A0', deep: '#4F877F' },
  pregnancy:    { light: '#D4919B', deep: '#B37079' },
  teen:         { light: '#7C7D82', deep: '#5C5D62' },
  safety:       { light: '#E06F5E', deep: '#B94E3F' },
  needs:        { light: '#D9AC5C', deep: '#B0873B' },
} as const

export type PackKey = keyof typeof PACK_COLORS

export const PACK_LABELS: Record<PackKey, string> = {
  early_care: 'Early Care',
  shopping:   'Shopping',
  health:     'Health',
  school:     'School',
  sports:     'Sports',
  activity:   'Activity',
  pregnancy:  'Pregnancy',
  teen:       'Teen',
  safety:     'Safety',
  needs:      'Needs',
}

/** Map a Need category to a pack (for color + icon). */
export function packForNeedCategory(cat: string): PackKey {
  switch (cat) {
    case 'feeding':
    case 'health':      return 'health'
    case 'clothing':
    case 'equipment':   return 'shopping'
    case 'appointment': return 'health'
    case 'education':
    case 'document':    return 'school'
    case 'activity':    return 'activity'
    case 'safety':      return 'safety'
    case 'financial':
    case 'logistics':
    case 'maintenance':
    case 'other':
    default:            return 'needs'
  }
}

/** Map an event type prefix to a pack. */
export function packForEvent(eventType: string): PackKey {
  if (eventType.startsWith('early_care.')) return 'early_care'
  if (eventType.startsWith('shopping.'))   return 'shopping'
  if (eventType.startsWith('growth.'))     return 'health'
  if (eventType.startsWith('need.'))       return 'needs'
  if (eventType.startsWith('family.'))     return 'needs'
  if (eventType.startsWith('person.'))     return 'needs'
  return 'needs'
}
